<style scoped lang="less">
  .main{
    width:100%;
    height: 100%;
  }
  .top_title{
    width: 100%;
    height: 3.5rem;
    background-color: rgb(6,160,156);
    border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px;
    text-align: center;
    box-sizing: border-box;
    color: #fff;
    font-size: 18px;
    line-height: 3.5rem;
    position: relative;
    .ztitle{
      width: 70%;
      display: inline-block;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行

    }
    .fanhui{
        position: absolute;
        left: 2rem;
        top: 50%;
        margin-top: 3px;
        transform:translateY(-50%);
    }
    .list_right{
        position: absolute;
        right: 2rem;
        top: 50%;
        margin-top: 3px;
        transform:translateY(-50%);
    }
  }
  .mbx{
      width:90%;
      margin:0 auto;    
      color:#20a5a2;
      border-bottom: 1px solid #20a5a2;
      padding:0.8rem 0px;
      font-size:14px;
  }
  .title{
    width:90%;
    margin:0 auto;
    color:#000;
    font-size:1.2rem;
    font-weight:bold;
    padding:1rem 0px 1rem 0px;
    box-sizing:border-box;
    // height:3.4rem;
    line-height: 1.3rem;
    // overflow : hidden;/*必须结合的属性,当内容溢出元素框时发生的事情*/
    // text-overflow: ellipsis;/*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
    // display: -webkit-box;/*必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
    // -webkit-line-clamp: 2;/*用来限制在一个块元素显示的文本的行数。*/
    // -webkit-box-orient: vertical;/*必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
  }
  .icon{
    width:90%;
    margin:0 auto;
    display:flex;
    flex-flow:row nowrap;
    justify-content: space-between;
    align-items:center;
    padding:1rem 0px;
    span{
      display:flex;
      flex-flow:row nowrap;
      justify-content: flex-start;
      align-items:center;
      color:rgb(165,173,185);
      img{
        margin-right:5px;
      }
    }
    span+span{
      color:rgb(243,28,109);
    }
  }
  /deep/.fwb{
    width:90%;
    margin:0 auto;
    position: relative;
    img{
      max-width:100% !important;
    }
    a{
      word-wrap:break-word !important;
      display: block !important;
    }
  }
  .vide{
    width:90%;
    margin:0 auto;
  }
  .img_ban{
    width:90%;
    margin:0 auto;
    height:7rem;
    padding: 0px 0px 1rem 0px;
    overflow: hidden;
    img{
      width:100%;
      height:100%;
      border-radius: 10px;
    }
  }
  .dianzan{
    width:100%;
    text-align:center;
    display:flex;
    flex-flow:row nowrap;
    justify-content: center;
    align-items:center;
    div{
      display:flex;
      flex-flow:row nowrap;
      justify-content: center;
      align-items:center;
      border-radius: 50%;
      border: 1px solid rgb(241,28,208);
      width: 2rem;
      height: 2rem;
      margin-right:5px;
      img{
        margin-top:-2px;
      }
    }
    .borders{
      border: 1px solid rgb(165,173,185);
    }
    .borders_red{
      border: 1px solid rgba(255,0,0,0.5);;
    }
  }
  /deep/.van-tabs{
    height: calc(100% - 18rem);
    width:100%;
  }
  /deep/.van-tabs__content{
      height:calc(100% - 2.8rem);
      width:100%;
      overflow-y: scroll;
  }
  /deep/.van-tab__pane{
      width:100%;
      // padding:0px 5%;
  }
  /deep/.van-tabs__line{
      width: 25%;
      background-color: rgb(6,160,156);
  }
</style>
<template>
  <div class="main">
    <div class="top_title">
        <span class="fanhui" @click="getBack()">
            <van-icon name="arrow-left" />
        </span>
        <span v-if="articleInfo" class="ztitle">
          <span>未来已来 不"溶"错过</span>
          <!-- <span v-if="articleInfo.type == 1">前沿资讯</span>
          <span v-if="articleInfo.type == 4">直播间</span>
          <span v-if="articleInfo.type == 3">科研成果</span>
          <span v-if="articleInfo.type == 2">见证实“例”</span>详情 -->
          <!-- {{articleInfo.title}} -->
        </span>
        <!-- <span v-if="articleInfo">{{articleInfo.title.length>=10?articleInfo.title.substring(0,10)+'...':articleInfo.title}}</span> -->
        <span class="list_right">
        </span>
    </div>
    <div class="mbx">
        <!-- <span @click="jumpUrl(1)"> -->
        <span @click="jumpUrl(1)">
          首页
          &nbsp;>&nbsp;
        </span>
        <!-- <span @click="jumpUrl(2)" v-if="urls !== '/'"> -->
        <!-- <span v-if="urls !== '/'"> -->
        <span @click="jumpUrl(2)">
          <span v-if="articleInfo.type == 1">前沿资讯</span>
          <span v-if="articleInfo.type == 4">直播间</span>
          <span v-if="articleInfo.type == 3">科研成果</span>
          <span v-if="articleInfo.type == 2">见证实“例”</span>
          <!-- &nbsp;>&nbsp; -->
        </span>
        <!-- <span>
            <span>{{articleInfo.title.length>=10?articleInfo.title.substring(0,10)+'...':articleInfo.title.length}}</span>
        </span> -->
        <!-- <span>
            <span>资讯详情</span>
        </span> -->
    </div>
    <div class="title">{{articleInfo.title}}</div>
    <div class="icon" v-if="type !== 3">
      <span>
        <img width="18px" src="../assets/image/homePage/sj.png">
        {{articleInfo.published_at_day}}
      </span>
      <span>
        <img width="18px" src="../assets/image/homePage/gk.png">
        {{articleInfo.page_views}}
      </span>
    </div>
    <div class="img_ban" v-if="type === 3">
      <img :src="articleInfo.image">
    </div>
    <div class="vide article_video" ref="article_video" id="article_video" v-show="articleInfo.type !== 4 && articleInfo.video_id"></div>
    <!-- <div class="vide article_video" ref="article_video" id="article_video" v-show="articleInfo.type === 2"></div> -->
    <div class="fwb" v-if="articleInfo.type === 1 || articleInfo.type === 2 || articleInfo.type === 3" v-html="articleInfo.content"></div>
    <!-- <div class="vide article_video" ref="article_video" id="article_video"></div> -->
    <div style="padding:2rem 0px 5rem 0px;" v-if="type !== 3">
      <div class="dianzan" >
        <!-- <div :class="iszan === 0?'borders':'borders_red'" class="borders_red" @click="zan"> -->
        <div class="borders_red" @click="zan">
          <img width="20px" v-if="iszan === 0" src="../assets/image/homePage/dzBX.png">  
          <img width="20px" v-if="iszan === 1" src="../assets/image/homePage/dzClick.png">  
        </div>
        {{articleInfo.zan_num}}人
      </div>
    </div>

    <van-tabs v-model="activeItem" @click="onClickTabs" v-if="type === 3">
        <van-tab title="专家风采">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad1"
            >
                <list :isDet="true" :listData="listData"></list>
            </van-list>
        </van-tab>
        <van-tab title="COE 介绍">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad2"
            >
                <list :listData="listData" :isDels="true"></list>
            </van-list>
        </van-tab>
        <van-tab title="活动介绍">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad3"
            >
                <list :listData="listData" :isDels="true"></list>
            </van-list>
        </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import list from '@/comm/list.vue'
import meSearch from '@/comm/meSearch.vue'
import Axios from "@/http/axios"
import $ from 'jquery';
import allApi from "@/http/allApi.js"

export default {
  name: "homePage",
  data() {
    return {
      id: '',
      type: '',
      articleInfo: '',
      iszan: 0,
      activeItem: '',
      finished:false,
      loading:false,
      listData:[],
      titles:"",
      urls:"",
      page:1,
    };
  },
  components: {
    list,
    meSearch
  },
  methods:{
    jumpUrl(i){
      console.log(i,111)
      if(i == 1){
        this.$router.push('/');
        return;
      }
      if(this.urls == '/'){
        this.$router.push('/list/'+this.articleInfo.type);
        return;
      }
      this.$router.push(this.urls);
    },
    getBack() {
      console.log(window.history.length);
      if (window.history.length <= 2) {
            this.$router.push({path:'/'})
            return false
        } else {
            this.hostType = true;
            this.$router.go(-1)
        }
    },
    onLoad(){
    },  
    onLoad1(){
      this.page+=1;
      this.getDetails();
    },  
    onLoad2(){
      this.page+=1;
      this.getDesc();
    },  
    onLoad3(){
      this.page+=1;
      this.getActivity()
    },  
    onSelect(action){
        console.log(action)
    },
    async zan() {
      if (this.iszan === 0) {
        const info = await Axios.post("/api/article/zan", {
          article_id: this.id
        })
        if (info.status === 200 && info.data.err_code === 0) {
          this.iszan = this.iszan === 0 ? 1 : 0;
          this.articleInfo.zan_num +=1;
        }
      }
    },
    async getIsZan() {
      const info = await Axios.post("/api/article/iszan", {
        article_id: this.id
      })
      if (info.status === 200 && info.data.err_code === 0) {
        this.iszan = info.data.data.is_zan
      }
    },
    async getDetails() {
      if (this.type === 3) {
        const info = await Axios.get("/api/coe-elegant/detail", { params: {
          coe_id: this.id,
          page:this.page
        }})
        if (info.status === 200 && info.data.err_code === 0) {
          this.articleInfo = info.data.data;
          this.listData = [];
          info.data.data.lecturer.forEach(element => {
              this.listData.push(element) 
          });
          this.loading = false;
          // if(info.data.data.lecturer.length==0){
            this.finished = true;
          // }
          if(this.activeItem!=0){
            this.onClickTabs(this.activeItem)
          }
        }
      } else {
        const info = await Axios.get("/api/article/detail", { params: {
          article_id: this.id
        }})
        if (info.status === 200 && info.data.err_code === 0) {
          this.articleInfo = info.data.data
          allApi.getShare().then(res=>{
            shareCommon(this.articleInfo.title,' ',res.data.data.img);
          })
          if (info.data.data.type !== 4 && this.articleInfo.video_id) {
          // if (info.data.data.type === 2) {
            this.$nextTick(()=>{
              const vedio =  $("#article_video")
              vedio.css({ "margin-top":"10px", "margin-bottom":"10px"});  
              let ww = vedio.width();
              vedio.height(ww * 0.5);
              let vid = this.articleInfo.video_id;//传视频ID
              let player = polyvObject("#article_video").videoPlayer({
              "width": `${ww}px`,
              "height": `${vedio.height()}px`,
              "vid": vid,
              "flashvars": {
                  "setScreen": "full",
                  "video_bg_color": "FFFFFF"
              }
              });
            });
          }
        }
      }
    },
    async getDesc() {
      const info = await Axios.get("/api/coe-elegant/desc", { params: {
        e_id: this.id,
          page:this.page
      }})
      if (info.status === 200 && info.data.err_code === 0) {
        info.data.data.forEach(element => {
            this.listData.push(element) 
        });
        this.loading = false;
        if(info.data.data.length==0){
          this.finished = true;
        }
      }
    },
    async getActivity() {
      const info = await Axios.get("/api/coe-elegant/activity", { params: {
        e_id: this.id,
          page:this.page
      }})
      if (info.status === 200 && info.data.err_code === 0) {
        info.data.data.forEach(element => {
            this.listData.push(element) 
        });
        this.loading = false;
        if(info.data.data.length==0){
          this.finished = true;
        }
      }
    },
    onClickTabs(value) {
      this.loading = false;
      this.finished = false;
      this.listData=[];
      this.page=1;
      switch (value) {
        case 0:
          this.getDetails()
          break
        case 1:
          this.getDesc()
          break
        case 2:
          this.getActivity()
          break
      }
      console.log(value)
    },
  },
  

  mounted(){
    // if(this.$route.query.titles){
    //   this.titles = this.$route.query.titles;
    // }
    if(this.$route.query.urls){
      this.urls = JSON.parse(this.$route.query.urls);
    }
    const { params, query } = this.$router.history.current
    if(params.id){
      this.id = parseInt(params.id)
    }
    if(query.type){
      this.type = parseInt(query.type)
    }
    if(sessionStorage.getItem("activeItem") !="" && sessionStorage.getItem("activeItem") !=null && sessionStorage.getItem("activeItem") != undefined){
      this.activeItem=Number(sessionStorage.getItem("activeItem"));
      sessionStorage.removeItem("activeItem");
      this.getDetails()
    }else{
      this.getDetails()
    }
    // this.getDetails()
    this.getIsZan()
  },
  beforeRouteLeave(to, form, next) {
    if(to.name == "detilesZJ" || to.name == "detilseNew" ){
      sessionStorage.setItem("activeItem",this.activeItem);
    }
    next()
  },
  watch:{
    $route(to,from) {
      const { params } = this.$router.history.current
      this.type = parseInt(query.type)
      this.id = parseInt(params.id)
      this.getDetails()
      this.getIsZan()
    }
  },
};


</script>
 
